import React from 'react';

import { connect } from 'react-redux';
import { hideSponsoredWarning } from 'services/actions/productsActions';
import { requestRemoveFromCart } from 'services/actions/cartActions';
import { gwpModalDefaultContentStyles } from './GwpModalDefaultContentStyles';

import BaseModal from '../../../shared-components/BaseModal/Modal';
import GwpPopupsContentWrapper from './GwpPopupsContentWrapper';

const RemoveGWPDisqualifyPopup = (props) => {
  const {
    shouldDisplayRemoveGWPDisqualifyPopup,
    hideSponsoredWarning,
    requestRemoveFromCart,
  } = props;

  return (
    <BaseModal
      showCloseIcon={false}
      isOpen={shouldDisplayRemoveGWPDisqualifyPopup}
      onRequestClose={hideSponsoredWarning}
      shouldCloseOnOverlayClick
      styles={gwpModalDefaultContentStyles}
    >
      <GwpPopupsContentWrapper
        title="Are You Sure You Want to Remove This Product?"
        description="Deleting this item will disqualify your free gift."
        requestRemoveFromCart={requestRemoveFromCart}
        hideSponsoredWarning={hideSponsoredWarning}
      />
    </BaseModal>
  );
};

const mapStateToProps = (state) => {
  return {
    shouldDisplayRemoveGWPDisqualifyPopup:
      state.productsState.shouldDisplayRemoveGWPDisqualifyPopup,
  };
};

export default connect(mapStateToProps, {
  hideSponsoredWarning,
  requestRemoveFromCart,
})(RemoveGWPDisqualifyPopup);
